module.exports = __webpack_public_path__ + "static/media/paper-icon.357e3974.svg";